/* Zuvi v6 behaviors — idempotent, deferred, reduced-motion aware.
   Loaded once (safe even if injected by several sections). */
(function () {
  if (window.__zuviInit) return;
  window.__zuviInit = true;

  var root = document.documentElement;
  root.classList.add('zuvi-on'); // enable reveal styling only when JS is alive

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    // 1) Marquee — duplicate the track so the loop is seamless
    document.querySelectorAll('[data-zuvi-marquee]').forEach(function (track) {
      if (track.dataset.zuviCloned) return;
      track.dataset.zuviCloned = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });

    // 2) Scroll reveal
    var reveals = document.querySelectorAll('.zuvi .reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }

    // 3) Hero parallax (blob + floating product)
    if (!reduce) {
      var b1 = document.querySelector('.zuvi-hero .hero-blob.b1');
      var prod = document.querySelector('.zuvi-hero .hero-prod');
      if (b1 || prod) {
        var ticking = false;
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var y = window.scrollY;
            if (b1) b1.style.transform = 'translateY(' + (y * 0.12) + 'px)';
            if (prod) prod.style.transform = 'translateY(' + (y * -0.05) + 'px)';
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    }

    // 4) Sticky CTA bar — show once the reader is past the hero, hide over the final offer
    document.querySelectorAll('[data-zuvi-sticky]').forEach(function (bar) {
      if (bar.dataset.zuviBound) return;
      bar.dataset.zuviBound = '1';

      var after = parseInt(bar.dataset.zuviSticky, 10);
      if (isNaN(after) || after < 0) after = 600;

      var overOffer = false;
      var stop = document.querySelector('.zuvi-offer');
      if (stop && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          overOffer = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.08 }).observe(stop);
      }

      var shown = false;
      function sync() {
        var want = !overOffer && window.scrollY > after;
        if (want === shown) return;
        shown = want;
        bar.classList.toggle('is-on', want);
      }

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
